// src/components/AdditionalChargesModal.jsx
import React from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";

const CHARGES = [
  {
    label: "Delivery – home and business",
    details: [
      "1–30 days: 100% (£150.00)",
      "31–60 days: 50% (£75.00)",
      "61–90 days: 25% (£37.50)",
      "90+ days: Inclusive (£0.00)",
    ],
  },
  {
    label: "Collection – home and business (with full costed appraisal)",
    details: [
      "1–30 days: 100% (£150.00)",
      "31–60 days: 50% (£75.00)",
      "61–90 days: 25% (£37.50)",
      "90+ days: Inclusive (£0.00)",
    ],
  },
  {
    label: "Waiting time – on delivery and collection (30-minute grace period)",
    details: ["£20.00 per hour"],
  },
  {
    label: "Vehicle changeover fee",
    details: [
      "1–30 days: 100% (£150.00)",
      "31–60 days: 50% (£75.00)",
      "61–90 days: 25% (£37.50)",
      "90+ days: Inclusive (£0.00)",
    ],
  },
  { label: "Aborted delivery", details: ["£150.00"] },
  { label: "Aborted collection", details: ["£150.00"] },
  {
    label:
      "Cancellation charge (if cancelled after 16:00 the day before delivery)",
    details: ["£150.00"],
  },
  { label: "Registration fee per day", details: ["£0.80"] },
  { label: "Mileage allowance", details: ["83 miles per day"] },
  { label: "Excess mileage", details: ["£0.20 per mile"] },
  { label: "Valet charge if required", details: ["£50.00"] },
  { label: "Vehicle recovery fee – driver fault", details: ["At cost"] },
  {
    label:
      "Administration fee (fines, traffic violations, congestion, dart, tolls)",
    details: ["Tolls £15.00", "All other fines £25.00"],
  },
  { label: "Damage administration charge", details: ["£30.00"] },
  { label: "Damage administration fee – total loss", details: ["£100.00"] },
  // {
  //   label: "Overseas breakdown cover",
  //   details: ["All vehicles are covered; please call 08000 323 277 option 7"],
  // },
  { label: "Overseas surcharges", details: ["Overseas pack (VE103B)"] },
];

export default function AdditionalChargesModal({ open, onClose }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div
        className="
          bg-white
          rounded-lg
          shadow-lg
          w-full max-w-3xl max-h-[90vh]
          overflow-y-auto
          text-gray-800
        "
      >
        {/* Header */}
        <div className="bg-primary px-6 py-3 rounded-t-lg flex items-center justify-between">
          <h2 className="text-white text-xl font-semibold">
            Additional charges
          </h2>
          <button
            onClick={onClose}
            aria-label="Close"
            className="p-1 rounded hover:bg-primary/80 transition"
          >
            <XMarkIcon className="h-6 w-6 text-white" />
          </button>
        </div>

        {/* Table */}
        <div className="p-6">
          <table className="w-full table-auto border-collapse">
            <thead>
              <tr>
                <th className="text-left py-2 px-4 text-gray-900">
                  Description
                </th>
                <th className="text-left py-2 text-gray-900">Charge</th>
              </tr>
            </thead>
            <tbody>
              {CHARGES.map((row, idx) => (
                <tr
                  key={row.label}
                  className={idx % 2 === 0 ? "bg-gray-50" : ""}
                >
                  <td className="align-top py-3 px-4 text-sm">{row.label}</td>
                  <td className="py-3 text-sm space-y-1">
                    {row.details.map((line, i) => (
                      <div key={i}>{line}</div>
                    ))}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Close button */}
          <div className="mt-6 text-right">
            <button
              onClick={onClose}
              className="px-4 py-2 bg-accent text-white rounded hover:bg-accent/90 transition"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
